export const ordenarPorDataAsc = <T,>(
	lista: T[],
	campoData: keyof T,
	campoContagem?: string,
): T[] => {
	const ordenada = [...lista].sort((a, b) => {
		const da = a[campoData] ? new Date(a[campoData] as any).getTime() : 0;
		const db = b[campoData] ? new Date(b[campoData] as any).getTime() : 0;
		return da - db;
	});

	if (campoContagem) {
		return ordenada.map((item, i) => ({ ...item, [campoContagem]: i + 1 }));
	}

	return ordenada;
};
